import { axios } from '@lib/axios';

import { PaymentService } from 'chaika-enums';

const BASE_URL = '/api/finance/system';

export class FinanceSystemApi {
    public static async reconcile(
        paymentProvider: PaymentService.PaymentProvider,
        terminalName: string,
    ): Promise<void> {
        await axios.post(`${BASE_URL}/reconciliation`, { paymentProvider, terminalName });
    }

    public static async sendReports(from: Date, to: Date): Promise<void> {
        const response = await axios.post(
            `${BASE_URL}/payments-report`,
            { from: from.toISOString(), to: to.toISOString() },
            {
                responseType: 'blob',
                timeout: 0,
            },
        );

        const href = URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', 'data.zip');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
    }
}
